module.exports = __webpack_public_path__ + "8bbd60cb6db09dd32faa5920fa3ee053.png";